import React from 'react';
import PropTypes from 'prop-types';
// todo: delete rename
import '../../../stylesheets/pages/preauth/components/ThemesIntro.less';
/* image imports */

const ThemesIntro = (props) => {
  const { onCtaClick } = props;
  return (
    <div className="themes-intro jumbotron">
      <div className="container">
        <div className="body">
          <h1>Create a <span className="script">free,</span>Beautiful Wedding Website</h1>
          <p className="preauth-intro-sub-header">Every custom website feature you could want or need, right here.</p>
          <div className="row">
            <div className="promo-bullet-container col-xs-12">
              <ul className="promo-bullet">
                <li className="zolaicon-checkmark"><span>Password protect your website.</span></li>
                <li className="zolaicon-checkmark"><span>Purchase a custom website domain name from Zola.</span></li>
              </ul>
            </div>
            <div className="promo-bullet-container col-xs-12">
              <ul className="promo-bullet second-promo">
                <li className="zolaicon-checkmark"><span>Integrate your Zola registry or <br className="visible-lg" /> link to one from another store.</span></li>
                <li className="zolaicon-checkmark"><span>Collect RSVPs, ask for meal <br className="visible-lg" />preferences, and more.</span></li>
              </ul>
            </div>
          </div>
          <button onClick={onCtaClick} className="btn btn-wide btn-primary btn-lg">Get Started</button>
        </div>
      </div>
    </div>
  );
};

ThemesIntro.propTypes = {
  onCtaClick: PropTypes.func,
};

export default ThemesIntro;



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/components/ThemesIntro.jsx
 **/